import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Actions
// import { getContactInformation } from '../../actions/settings'

// import styles
import './settings.scss'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../utils/auth'
import { translation } from '../../utils/helpers'

// import components
import Header from '../../shared/components/Header'
// import LeftMenu from '../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../shared/components/Menus/LeftMenu/Content'

import SideMenu from '../../shared/elements/sideMenu'
import SideMenuItem from '../../shared/elements/sideMenuItem'

// Views
import Contact from './Contact'
import PunchClock from './PunchClock'
import Forsi from './Forsi'
import Invoicing from './Invoicing'
import ClosingDays from './ClosingDays'
import Process from './Process'
import OrderInspection from './OrderInspection'
import Booking from './Booking'
import Delivery from './Delivery'
import ChainNotification from './ChainNotification'
import ViewSettings from './ViewSettings'
import PaintTool from './PaintTool'
import CarRental from './CarRental'
import ProcessManagement from './ProcessManagement'
import BookingPortal from './BookingPortal'
import CarOwnerPortal from './CarOwnerPortal'
import SupportAccess from './SupportAccess'
import CompanyStyling from './CompanyStyling'
import CarOwnerNotification from './CarOwnerNotification'

class Settings extends Component {

  constructor (props) {
    super(props)
    this.state = {
      valid: [
        {
          name: 'contact'
        },
        {
          name: 'punchclock'
        },
        {
          name: 'forsi'
        },
        {
          name: 'invoicing'
        },
        {
          name: 'closingdays'
        },
        {
          name: 'process'
        },
        {
          name: 'orderinspection'
        },
        {
          name: 'booking'
        },
        {
          name: 'delivery'
        },
        {
          name: 'chainnotification'
        },
        {
          name: 'viewsetting'
        },
        {
          name: 'painttool'
        },
        {
          name: 'carrental'
        },
        {
          name: 'processmanagement'
        },
        {
          name: 'bookingportal'
        },
        {
          name: 'carownerportal'
        },
        {
          name: 'companystyling'
        },
        {
          name: 'carownernotification'
        },
        {
          name: 'supportaccess'
        }
      ]
    }
  }

  componentDidMount () {
    if (!this.isValidPage()) {
      this.props.router.push('/settings')
    }
  }

  componentDidUpdate () {
    if (!this.isValidPage()) {
      this.props.router.push('/settings')
    }
  }

  isValidPage () {
    let valid = true
    let found = false
    if (typeof this.props.params.type !== 'undefined') {
      this.state.valid.map((val, key) => {
        if (val.name === this.props.params.type) {
          found = true
        }
      })
      if (!found) {
        valid = false
      }
    }
    return valid
  }

  leftMenu () {
    const renderMenuItem = (to, label, classDefault) => {
      const renderLink = (linkLabel, className, activeClass) => {
        return (
          <Link
            to={to}
            className={className + (classDefault ? ' ' + classDefault : '')}
            activeClassName={activeClass}
          >
            {linkLabel}
          </Link>
        )
      }

      return (
        <SideMenuItem
          label={label}
          renderLabel={renderLink}
          key={to}
        />
      )
    }

    const isEmployeeOrShopOwner = hasAccess([3, 7], this.props.auth.user.UserType)
    let assessmentSystemText = null
    switch (this.props.auth.permissions.ChainAssessmentSystem) {
      case 1:
        assessmentSystemText = translation('13438')
        break
      case 2:
        assessmentSystemText = translation('17930')
        break
      default:
        break
    }

    return [
      // <div>
      //   <ul>
      isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 0, 11) && renderMenuItem('/settings/contact', translation('346')),
      isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 10, 11) && renderMenuItem('/settings/booking', translation('13373')),
      hasSubscriptionPermission(this.props.auth, 10, 11) && renderMenuItem('/settings/closingdays', translation('504')),
      this.props.auth.hasPartner && this.props.auth.departmentType === 1 && isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 20) && renderMenuItem('/settings/processmanagement', translation('15251')),
      isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 20, [19, 12]) && renderMenuItem('/settings/punchclock', translation('437')),
      isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 10) && renderMenuItem('/settings/orderinspection', translation('13423')),
      /* this.props.auth.departmentType !== 1 && */ isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 20, 11) && renderMenuItem('/settings/process', translation('165')),
      isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 0, 11) && this.props.auth.permissions.ChainAssessmentSystem > 0 && renderMenuItem('/settings/forsi', assessmentSystemText),
      isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 10, 6) && renderMenuItem('/settings/invoicing', translation('13486')),
      /* <li><Link to='/settings/partners' activeClassName='active'>{translation('649')}</Link></li> */
      this.props.auth.departmentType !== 1 && isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 20, 11) && renderMenuItem('/settings/delivery', translation('196')),
      hasAccess([2], this.props.auth.user.UserType) && renderMenuItem('/settings/chainnotification', translation('2214')),
      isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 20, 11) && renderMenuItem('/settings/viewsetting', translation('14791')),
      this.props.auth.departmentType !== 1 && this.props.auth.permissions.ChainAllowPaintTool > 0 && isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 10, 11) && renderMenuItem('/settings/painttool', translation('14965')),
      isEmployeeOrShopOwner && this.props.auth.departmentType !== 0 && hasSubscriptionPermission(this.props.auth, 20, 11) && renderMenuItem('/settings/carrental', translation('14778')),
      isEmployeeOrShopOwner && this.props.auth.permissions.AllowBookingPortal === true && renderMenuItem('/settings/bookingportal', translation('16681')),
      isEmployeeOrShopOwner && this.props.auth.permissions.AllowCarOwnerPortal === true && renderMenuItem('/settings/carownerportal', translation('18152')),
      isEmployeeOrShopOwner && this.props.auth.permissions.AllowCarOwnerPortal === true && this.props.auth.permissions.CarOwnerPortalEnabled === true && renderMenuItem('/settings/carownernotification', translation('18186')),
      isEmployeeOrShopOwner && (this.props.auth.permissions.AllowCarOwnerPortal === true || this.props.auth.permissions.AllowBookingPortal === true) && renderMenuItem('/settings/companystyling', translation('18188')),
      isEmployeeOrShopOwner && hasSubscriptionPermission(this.props.auth, 0, 33) && renderMenuItem('/settings/supportaccess', translation('17967'))
      //   </ul>
      // </div>
    ]
  }

  renderHeaderTitle () {
    return translation('6')
  }

  renderView () {
    // console.log('this.props.params.type', this.props.params.type)
    switch (this.props.params.type) {
      case 'contact':
        return <Contact />
      case 'punchclock':
        return <PunchClock />
      case 'forsi':
        return <Forsi />
      case 'invoicing':
        return <Invoicing />
      case 'closingdays':
        return <ClosingDays />
      case 'process':
        return <Process />
      case 'orderinspection':
        return <OrderInspection />
      case 'booking':
        return <Booking />
      case 'delivery':
        return <Delivery type='shop' />
      case 'chainnotification':
        return <ChainNotification />
      case 'viewsetting':
        return <ViewSettings />
      case 'painttool':
        return <PaintTool />
      case 'carrental':
        return <CarRental />
      case 'processmanagement':
        return <ProcessManagement />
      case 'bookingportal':
        return <BookingPortal />
      case 'carownerportal':
        return <CarOwnerPortal />
      case 'carownernotification':
        return <CarOwnerNotification />
      case 'supportaccess':
        return <SupportAccess />
      case 'companystyling':
        return <CompanyStyling />
      default:
        return null
    }
  }

  render () {
    return (
      <div className='settings__screen'>
        <Header router={this.props.router} />

        <SideMenu showFilter={false} hideInactiveCheck>
          {this.leftMenu()}
        </SideMenu>

        <LeftMenuContent className='settings__screen--inner clearfix'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }

}

Settings.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {})(Settings)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/index.js